import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React from 'react';
import { Helmet } from 'react-helmet';
import { ImagePropType } from '../../../../services/proptypes';
import { getImageSrc } from '../../../../utils/images';
import { addIfNotEmpty } from '../LocalBusinessSchema/LocalBusinessSchema.utils';
import { formatServiceOffers, formatServiceOutput } from '../transformers/service';
import { BusinessProviderPropType } from '../types/business';
import { getBusinessSchemaType } from '../utils/business';
import { getImage } from '../utils/image';
import { markdownToPlainText } from '../utils/markdown';
var defaultProps = {
  description: '',
  image: null,
  prices: [],
  duration: '',
  durationUnit: ''
};
export default function ServiceItemSchema(_ref) {
  var businessName = _ref.businessName,
    businessCategories = _ref.businessCategories,
    name = _ref.name,
    categoryName = _ref.categoryName,
    description = _ref.description,
    image = _ref.image,
    prices = _ref.prices,
    duration = _ref.duration,
    durationUnit = _ref.durationUnit;
  var schema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    serviceType: categoryName,
    name: name,
    description: markdownToPlainText(description),
    provider: {
      '@type': getBusinessSchemaType(businessCategories),
      name: businessName
    }
  };
  schema = addIfNotEmpty(schema, 'image', getImageSrc(getImage(image)));
  schema = addIfNotEmpty(schema, 'serviceOutput', formatServiceOutput({
    duration: duration,
    durationUnit: durationUnit
  }));
  schema = addIfNotEmpty(schema, 'offers', formatServiceOffers({
    prices: prices
  }));
  return /*#__PURE__*/React.createElement(Helmet, {
    defer: false
  }, /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json"
  }, JSON.stringify(schema)));
}
ServiceItemSchema.defaultProps = defaultProps;